import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class TestSlotsService {

  private path = '/test-slots';

  constructor(private backendService: BackendService) { }



  saveTestSlots(createExam: any) {
    return this.backendService.post(this.path + '/save', createExam);
  }



  getTestSlotsById(id) {
    return this.backendService.get(this.path + '/slot/' + id);
  }

  deleteTestSlots(id) {

    return this.backendService.post(this.path + '/delete/' + id, {});
  }


  searchTestSlots(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);

  }




}


